type UseOciSessionType = {
    isOciSession: boolean;
    hookUrl?: string;
    charset?: string;
    returnTarget?: string;
};

const LOCAL_STORAGE_KEY = 'ociSession';

export const useOciSession = (isUserLoggedIn: boolean): UseOciSessionType => {
    if (!isUserLoggedIn) {
        return { isOciSession: false };
    }

    const ociSessionString = localStorage.getItem(LOCAL_STORAGE_KEY);

    if (ociSessionString) {
        const sessionData = JSON.parse(ociSessionString);

        return {
            isOciSession: true,
            hookUrl: sessionData.hookUrl,
            charset: sessionData.charset,
            returnTarget: sessionData.returnTarget
        };
    }

    return { isOciSession: false };
};
